import {
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Switch,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { AdvancedOptionsContainer, OptionGroup } from "components/Styled";
import { useRuleContext } from "pages/Rules/Form/context/ruleContext";

import { EmailFlow } from "@dashboard-v3/api";
import SwitchField from "components/Forms/SwitchField";
import { ChangeEvent } from "react";
import { getEmailFlow, typePath } from "pages/Rules/Form/context/ruleSelectors";

export default function AdvancedOptions() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const emailFlow: EmailFlow = getEmailFlow(state.rule);
  const isCopyEmails = state.rule.actionType === "COPY_EMAILS";
  const isSendDelay = state.rule.actionType === "SEND_DELAY";
  const isEvaluateHeadersEnabled = !isSendDelay || emailFlow.smtpPhase;

  function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, checked } = event.target;

    dispatch({
      type: "updateStep",
      payload: {
        step: "target",
        changes: { [name]: checked },
      },
    });
  }

  return (
    <AdvancedOptionsContainer>
      <AccordionSummary
        data-testid="emailflow__advanced-options-expand"
        expandIcon={<ExpandMoreIcon />}
        style={{ padding: "0 24px" }}
      >
        <Typography>{t("advancedOptions")}</Typography>
      </AccordionSummary>
      <AccordionDetails
        style={{ padding: "8px 24px 24px", flexDirection: "column" }}
      >
        {isEvaluateHeadersEnabled && (
          <OptionGroup>
            <FormControlLabel
              control={
                <Switch
                  name="evaluateHeaders"
                  color="primary"
                  onChange={handleOnChange}
                  checked={emailFlow.evaluateHeaders}
                  disabled={emailFlow.evaluateFrom}
                />
              }
              label={
                <Typography style={{ fontWeight: "500" }} variant="subtitle1">
                  {t("evaluateConditionDescription")}
                </Typography>
              }
            />
          </OptionGroup>
        )}
        <OptionGroup>
          <FormControlLabel
            control={
              <Switch
                name="evaluateFrom"
                color="primary"
                checked={emailFlow.evaluateFrom}
                disabled={emailFlow.evaluateHeaders}
                onChange={handleOnChange}
              />
            }
            label={
              <Typography style={{ fontWeight: "500" }} variant="subtitle1">
                {t("evaluateFromHeaderDescription")}
              </Typography>
            }
          />
        </OptionGroup>
        {isCopyEmails && (
          <OptionGroup>
            <SwitchField
              name="saveForwardedMessages"
              label={t("saveForwardedMessages")}
              description={t("saveForwardedMessagesAsAttachmentsSeparately")}
              value={typePath("COPY_EMAILS", state.rule).saveForwardedMessages}
              onChange={handleOnChange}
            />
          </OptionGroup>
        )}
      </AccordionDetails>
    </AdvancedOptionsContainer>
  );
}
